export default (newName) => ({
    init() {
        this.newName = newName;
        this.originalName = this.$el.getAttribute('name');

        if (!this.originalName || !this.newName) return;

        this._handler = this.handleRequest.bind(this);
        window.addEventListener('htmx:configRequest', this._handler);
    },

    destroy() {
        window.removeEventListener('htmx:configRequest', this._handler);
    },

    handleRequest(event) {
        const formData = event.detail.formData;
        if (!(formData instanceof FormData)) return;

        if (formData.has(this.originalName)) {
            const value = formData.get(this.originalName);
            formData.delete(this.originalName);
            formData.set(this.newName, value);
        }
    }
});